import {
  Component,
  Input,
  Output,
  OnInit,
  SimpleChanges,
  EventEmitter
} from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Observable, of } from "rxjs";
import { MatSnackBar } from "@angular/material";
import { DatePipe } from "@angular/common";

import { Questionario } from "../models/questionario";
import { CategoriaPergunta } from "../models/categoria-pergunta";
import { Resposta } from "../models/resposta";
import { RespostaItem } from "../models/resposta-item";
import { Question } from "../models/question";
import { OpcaoGenerica } from "../models/opcao-generica";
import { FileUpload } from "../models/file-upload";
import { QuestionModel } from "../models/question-model";
import { TipoRespostaEnum } from "../util/tipo-resposta.enum";
import { SituacaoEnum } from "../util/situacao.enum";
import { MatTabChangeEvent } from "@angular/material";

import { QuestionarioDinamicoService } from "../services/questionario-dinamico.service";
import { RespostaListaDinamicaService } from "../services/resposta-lista-dinamica.service";


@Component({
  selector: "questionario-dinamico",
  template: `<div *ngIf="isLoading || salvando">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>

<!-- Formulario Questionario Dinamico -->
<div class="row clearfix" *ngIf="!isLoading">
  <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
    <div class="card">
      <div class="alert {{mensagem[1]}}" *ngIf="mensagem">
        <strong> {{mensagem[0]}} </strong>
      </div>
      <div *ngIf="mostrarCabecalho" class="header">
        <h2>{{questionario.denominacao}}</h2>
      </div>
      <div class="body">

        <mat-tab-group (selectChange)="tabChanged($event)" [selectedIndex]="tabAtual">
          <mat-tab *ngFor="let item of categorias; let i=index" label="{{ item.denominacao }}">

            <form [formGroup]="form" *ngIf="questionModel && questionModel.questions.length > 0"
              style="margin-top: 20px;">
              <div class="alert alert-danger" *ngIf="this.mensagemErros != null && this.mensagemErros.length >0">
                <strong>Existem erros no formulário:</strong>
                <li *ngFor="let erro of mensagemErros; let i=index">
                  <strong>{{erro}}</strong>
                </li>
              </div>
              <div *ngFor="let question of questionModel.questions">
                <div *ngIf="mostraPergunta(question)">
                  <div *ngIf="question.idCategoria == item.id">
                    <div class="form-group">
                      <div class="form-line">
                        <small class="text-danger"
                          *ngIf="form.controls[question.key].hasError('maxlength') && form.controls[question.key].touched">*máximo
                          de {{question.limitMax}} caracteres</small>
                        <small class="text-danger"
                          *ngIf="form.controls[question.key].hasError('minlength') && form.controls[question.key].touched">*mínimo
                          de {{question.limitMin}} caracteres</small>
                        <label class="text-danger" *ngIf="question.alerta">{{question.alerta}}</label>
                        <div [ngSwitch]="question.controlType">
                          <div *ngSwitchCase="'textbox'">
                            <mat-form-field class="full-width" [ngStyle]="question.style">
                              <span matTooltip="{{question.tooltip}}">
                                <input matInput placeholder="{{question.text}}" id="{{question.key}}"
                                  [formControlName]="question.key">
                              </span>
                            </mat-form-field>
                          </div>
                          <div *ngSwitchCase="'inteiro'">
                            <mat-form-field class="full-width" [ngStyle]="question.style">
                              <span matTooltip="{{question.tooltip}}">
                                <input matInput placeholder="{{question.text}}" id="{{question.key}}"
                                  [formControlName]="question.key" type="number" min="0" step="1">
                              </span>
                            </mat-form-field>
                          </div>
                          <div *ngSwitchCase="'decimal'">
                            <mat-form-field class="full-width" [ngStyle]="question.style">
                              <span matTooltip="{{question.tooltip}}">
                                <input matInput placeholder="{{question.text}}" id="{{question.key}}"
                                  (change)="converteDecimal(question.key)" [formControlName]="question.key" type="text">
                              </span>
                            </mat-form-field>
                          </div>
                          <div *ngSwitchCase="'data'">
                            <span matTooltip="{{question.tooltip}}">
                              <mat-form-field class="full-width" [ngStyle]="question.style">
                                <input matInput placeholder="{{question.text}} (dd/mm/aaaa)" id="{{question.key}}"
                                  [formControlName]="question.key">
                              </mat-form-field>
                            </span>
                          </div>
                          <div *ngSwitchCase="'textarea'">
                            <mat-form-field class="full-width" [ngStyle]="question.style">
                              <span matTooltip="{{question.tooltip}}">
                                <textarea matInput placeholder="{{question.text}}" id="{{question.key}}"
                                  [formControlName]="question.key"></textarea>
                              </span>
                            </mat-form-field>
                          </div>
                          <div *ngSwitchCase="'dropdown'">
                            <span matTooltip="{{question.tooltip}}" [ngStyle]="question.style">
                              <label>{{question.text}}</label>
                            </span>
                            <mat-select [formControlName]="question.key" (change)="apagaFilhos(question)"
                              [ngStyle]="question.style">
                              <mat-option *ngFor="let o of question.options" [value]="o.id">
                                {{o.descricao}}
                              </mat-option>
                            </mat-select>

                          </div>
                          <div *ngSwitchCase="'radio'">
                            <div [ngStyle]="question.style">
                              <span matTooltip="{{question.tooltip}}">
                                <label>{{question.text}}</label>
                              </span>
                            </div>
                            <div [ngStyle]="question.style">
                              <mat-radio-group class="radio-vertical" [formControlName]="question.key"
                                (change)="apagaFilhos(question)">
                                <mat-radio-button *ngFor="let o of question.options" [value]="o.id">
                                  {{o.descricao}}
                                </mat-radio-button>
                              </mat-radio-group>
                            </div>
                          </div>
                          <div *ngSwitchCase="'select-multiple'">
                            <span matTooltip="{{question.tooltip}}" [ngStyle]="question.style">
                              <label>{{question.text}}</label>
                            </span>
                            <div *ngFor="let o of question.options" class="checkbox" [ngStyle]="question.style">
                              <label>
                                <input class="filled-in" type="checkbox" [formControlName]="question.key" [value]="o.id"
                                  [checked]="displayValue(question.key, o.id)"
                                  (change)="updateMultipleComponent(o.id, $event.target.checked, null, question.key)">{{o.descricao}}
                              </label>
                            </div>
                          </div>
                          <div *ngSwitchCase="'divisor'">
                            <mat-toolbar color="primary" layout="row" layout-align="center center">
                              <p>{{question.text}}</p>
                            </mat-toolbar>
                          </div>
                          <div *ngSwitchCase="'arquivo'">
                            <div [ngStyle]="question.style">
                              <span matTooltip="{{question.tooltip}}">
                                <label>{{question.text}}</label>
                              </span>

                              <questionario-file-upload [listaArquivos]="listaArquivos" [idPergunta]="question.key"
                                [idResposta]="resposta?.id" [quantidadeMaximaArquivos]="question.limitMax"
                                [desabilitado]="question.disable" [mostrarSalvar]="botaoSalvar"
                                (arquivoIncluido)="arquivoIncluidoEmitido($event)"
                                (arquivoExcluido)="arquivoExcluidoEmitido($event)"> </questionario-file-upload>
                            </div>
                          </div>
                          <div style="display: inline-block; text-align: right; width: 100%"
                            *ngIf="botaoSelecionarPergunta">
                            <button mat-raised-button color="primary" (click)="selecionarPergunta(question.key)">
                              <i class="material-icons">input</i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div style="float: right;">
                <span>
                  <small class="text-danger">(*) Campos Obrigatórios</small>
                </span>
              </div>

              <button mat-raised-button type="submit" color="primary" (click)="continuar(form.value)"
                *ngIf="this.questionario.mostrarSalvarConcluir && botaoSalvar && tabAtual < (categorias.length -1) ">
                <mat-icon>play_arrow</mat-icon> Continuar
              </button>

              <button mat-raised-button type="submit" color="primary" (click)="saveConcluir(form.value)"
                *ngIf="botaoSalvar">
                <mat-icon>save</mat-icon> {{nomeBotaoSalvar}}
              </button>



              <button mat-raised-button color="primary" *ngIf="botaoResetar" (click)="resetar()">
                <mat-icon>refresh</mat-icon> Limpar
              </button>

            </form>
          </mat-tab>

        </mat-tab-group>

      </div>
    </div>
  </div>
</div>`
})
export class QuestionarioDinamicoComponent implements OnInit {
  // idQuestionario vem da pagina que usara o componente
  @Input() idQuestionario: number;
  // nomeUnico vem da pagina que usara o componente
  @Input() nomeQuestionario: string;
  // esse Input, permite que o usuário já carregue um questionário pre-carregado para o componente.
  // isso melhora a performance, pois esse componente nao precisa ficar carregando o questionario toda hora.
  @Input() questionarioPreCarregado: Questionario;
  // respostas do questionario que pode vim de outra pagina
  @Input() resposta: Resposta;
  // id de uma resposta que pode vim de outra pagina
  @Input() idResposta: number;
  // botao para resetar formulario
  @Input() mostrarCabecalho: boolean;
  // botao para resetar formulario
  @Input() botaoResetar: boolean;
  // botao para salvar formulario
  @Input() botaoSalvar: boolean;
  // botao para selecionar uma pergunta no formulario
  @Input() botaoSelecionarPergunta: boolean;
  // botao para salvar formulario
  @Input() parametroMetodoInicializador: string;
  // botao para salvar formulario
  @Input() parametroMetodoValidador: string;
  // Esse input eh usado pra casos onde o questionario abre na mesma tela.
  // Quem chamar o camponente, passa esse input como true pra resetar o componente
  @Input() novoEmmiter: boolean;
  // caso queira que nao mostre a mensagem de salvar
  @Input() mostrarMensagemSalvar: boolean = true;
  // caso o usuario queira mudar o nome do botao concluir
  @Input() nomeBotaoSalvar: string = "Salvar";
  // Emite a resposta
  @Output() respostaEmitida: EventEmitter<number> = new EventEmitter<number>();
  // Emite a resposta completa
  @Output() respostaCompletaEmitida: EventEmitter<Resposta> = new EventEmitter<Resposta>();
  // Emite a situacao
  @Output() situacaoEmitida: EventEmitter<number> = new EventEmitter<number>();
  // Emite a pergunta que foi selecionada
  @Output() perguntaEmitida: EventEmitter<number> = new EventEmitter<number>();
  public tabAtual: number;

  public mensagem: [string, string];
  public mensagemErros: string[];
  public questionario: Questionario;
  public questionarioCompleto: Questionario;
  public categorias: CategoriaPergunta[];
  public categoriaSelecionada: CategoriaPergunta;
  public situacaoResposta: number;
  public form: FormGroup;
  public questionModel = new QuestionModel();
  // Controla o loading da página
  public isLoading: boolean;
  // o salvando tbm eh um loading, soh que eu nao escondo o componente. Assim, nao precisa renderizar novamente.
  public salvando: boolean;
  public respostaValida: boolean;

  public multipleComponentChecked: Array<{
    idOpcao: number;
    value: boolean;
    idItem: number;
    idPergunta: number;
  }> = new Array<{
    idOpcao: number;
    value: boolean;
    idItem: number;
    idPergunta: number;
  }>();
  // TODO: IMPLEMENTAR DESSA FORMA type Product = { productId: number, price: number, discount: number };

  public listaArquivos: FileUpload[];
  // variavel auxiliar, para criar o objeto do UploadModel
  public arquivoGlobal: string;

  // determina a largura da Tela
  public classeComponentes: string;
  public classeBotaoSelecionarPergunta: string;

  constructor(
    public mensagemSnack: MatSnackBar,
    public questionarioDinamicoService: QuestionarioDinamicoService,
    public respostaListaDinamicaService: RespostaListaDinamicaService,
    public datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.tabAtual = 0;
    this.categoriaSelecionada = new CategoriaPergunta();
    this.questionario = new Questionario();
    if (this.idQuestionario || this.nomeQuestionario || this.questionarioPreCarregado) {
      this.carregaQuestionario(this.idQuestionario, this.nomeQuestionario, this.questionarioPreCarregado);
    } else {
      this.mensagem = [
        "Erro: " +
        "Entre com um valor para o idQuestionario ou nomeUnicoQuestionario",
        "alert-danger"
      ];
    }

    // controla o estilo dos componentes
    if (this.botaoSelecionarPergunta) {
      this.classeComponentes = "col-lg-11 col-md-11 col-sm-11 col-xs-11";
      this.classeBotaoSelecionarPergunta =
        "col-lg-1 col-md-1 col-sm-1 col-xs-1";
    } else {
      this.classeComponentes = "col-lg-12 col-md-12 col-sm-12 col-xs-12";
    }
  }

  public carregaQuestionario(idQuestionario: number, nomeQuestionario: string, questionarioPreCarregado: Questionario) {
    this.nomeQuestionario = nomeQuestionario;
    this.idQuestionario = idQuestionario;
    this.questionarioPreCarregado = questionarioPreCarregado;

    this.isLoading = true;
    this.questionModel = new QuestionModel();
    let questionarioRecuperado: Observable<Questionario> = new Observable<Questionario>();

    if (this.questionarioPreCarregado) {
      questionarioRecuperado = of(this.questionarioPreCarregado);
    } else if (this.idQuestionario) {
      questionarioRecuperado = this.questionarioDinamicoService.recuperaQuestionarioCompleto(
        this.idQuestionario,
        ""
      );
    } else if (this.nomeQuestionario) {
      questionarioRecuperado = this.questionarioDinamicoService.recuperaQuestionarioCompleto(
        0,
        this.nomeQuestionario
      );
    }

    questionarioRecuperado.subscribe(
      resultQuestionario => {
        if (
          resultQuestionario != null &&
          resultQuestionario.id != null &&
          resultQuestionario.id != 0
        ) {
          this.preencheObjetoQuestionario(resultQuestionario);
          // Se jah chegar com resposta preenchida, entao eu eu recupero a resposta
          if (this.resposta || this.idResposta) {
            // se tiver resposta, entao eh uma alteracao
            this.recuperaResposta(this.resposta, this.idResposta);
          } else {
            // se nao chegar, entao eu chamo o respostaInicial
            this.preencheRespostaInicial(resultQuestionario);
          }
        } else {
          this.mensagem = [
            "Nenhum questionário ativo encontrado.",
            "alert-danger"
          ];
          this.isLoading = false;
        }
      },
      error => this.erro(error)
    );
  }

  /**
   * Recupera a resposta de um questionário.  
   * @param resposta Resposta completa já recuperada
   * @param idResposta id de uma Resposta
   */
  public recuperaResposta(resposta: Resposta, idResposta: number) {
    if (resposta) {
      this.preencheValoresResposta(resposta);
      this.isLoading = false;
    } else if (idResposta != null && idResposta != undefined && idResposta != 0) {
      this.respostaListaDinamicaService.getRespostaPorIdCompleta(idResposta).subscribe(result => {
        this.preencheValoresResposta(result);
        this.isLoading = false;
      },
        error => this.erro(error)
      );
    }
  }

  /**
   * Preenche os valores do
   */
  public preencheValoresResposta(resposta: Resposta) {
    this.resposta = resposta;
    if (this.resposta && this.resposta.listaRespostaItem) {
      this.resposta.listaRespostaItem.forEach(item => {
        this.questionario.categorias.forEach(cat => {
          cat.perguntas.forEach(per => {
            if (per.id == item.pergunta) {
              if (
                per.tipoResposta == TipoRespostaEnum.EscolhaUma ||
                per.tipoResposta == TipoRespostaEnum.Combo
              ) {
                this.form.controls[item.pergunta].patchValue(item.opcaoValor);
              } else if (
                per.tipoResposta == TipoRespostaEnum.TextoSimples ||
                per.tipoResposta == TipoRespostaEnum.TextoGrande
              ) {
                this.form.controls[item.pergunta].patchValue(item.descricao);
              } else if (
                per.tipoResposta == TipoRespostaEnum.Inteiro ||
                per.tipoResposta == TipoRespostaEnum.Decimal
              ) {
                this.form.controls[item.pergunta].patchValue(item.numero);
              } else if (per.tipoResposta == TipoRespostaEnum.Data) {
                this.form.controls[item.pergunta].patchValue(item.data);
              } else if (per.tipoResposta == TipoRespostaEnum.MultiplaEscolha) {
                // a regra eh a seguinte: a opcaoValor pode nao existir no banco(se o cara marcar e desmarcar)
                // por isso, se ela nao existir, eu passo o item.opcao, pois esse eh certeza q exista, mesmo quando o usuario desmarque.
                if (item.opcaoValor) {
                  this.updateMultipleComponent(
                    item.opcaoValor,
                    true,
                    item.id,
                    item.pergunta
                  );
                } else {
                  this.updateMultipleComponent(
                    item.opcao,
                    false,
                    item.id,
                    item.pergunta
                  );
                }
              } else if (per.tipoResposta == TipoRespostaEnum.Arquivo) {
                // this.listaArquivosEditar.set(per.id, item.itemRespostaArquivo);
              }
            }
          });
        });
      });
    }

    if (this.resposta.listaRespostaItemArquivo) {
      this.listaArquivos = this.resposta.listaRespostaItemArquivo;
    }
  }

  public preencheObjetoQuestionario(resultQuestionario: Questionario) {
    this.questionario = resultQuestionario;
    if (
      this.questionario.categorias != null &&
      this.questionario.categorias.length > 0
    ) {
      // pega a primeira categoria
      this.categorias = this.questionario.categorias;
      this.categoriaSelecionada = this.categorias[0];
    } else {
      this.mensagem = [
        "Nenhuma categoria cadastrada. Por favor, cadastre pelo menos uma.",
        "alert-danger"
      ];
    }

    if (resultQuestionario && resultQuestionario.categorias) {
      this.form = this.questionModel.carregaForm(
        resultQuestionario.categorias,
        false
      );
    }
  }

  public preencheRespostaInicial(resultQuestionario: Questionario) {
    if (resultQuestionario.metodoInicializador) {
      this.respostaListaDinamicaService
        .getRespostaInicial(
          resultQuestionario.id,
          this.parametroMetodoInicializador
        )
        .subscribe(
          result => {
            this.recuperaResposta(result, 0);
          },
          error => this.erro(error)
        );
    } else {
      this.isLoading = false;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    for (let propName in changes) {
      let chng = changes[propName];
      // se for a primeira vez q entrou..
      if (propName == "novoEmmiter") {
        let novoBotao: boolean = chng.currentValue;
        if (novoBotao) {
          this.resetar();
        }
      }
    }
  }

  // metodo que decide se a pergunta vai aparecer ou nao. Isso vai depender se ela eh vinculada ou nao a outra pergunta
  public mostraPergunta(question: Question): boolean {
    if (question.perguntaVinculada == null) {
      return true;
    } else {
      // checkboxes tem uma regra diferente pq eu guardo os valores dele em um array. Por isso ele eh diferente
      if (
        this.form.controls[question.perguntaVinculada.opcao.pergunta] != null &&
        this.form.controls[question.perguntaVinculada.opcao.pergunta].value ==
        question.perguntaVinculada.idOpcao
      ) {
        return true;
      } else {
        // se chegar aki, entao provavelmente eh um checkbox (eu poderia ter feito essa consulta lah em cima, mas to economizando recursos assim)
        let opcaoMarcada: any = this.multipleComponentChecked
          .filter(valor => valor.value == true)
          .find(valor => valor.idOpcao == question.perguntaVinculada.idOpcao);
        if (opcaoMarcada) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  public displayValue(questionKey: any, numero: any) {
    if (this.multipleComponentChecked) {
      if (
        this.multipleComponentChecked
          .filter(x => x.idOpcao == numero)
          .filter(x => x.idPergunta == questionKey)
          .filter(x => x.value == true).length > 0
      ) {
        return true;
      }
    }
  }

  /*
    * Metodo que controla as opcoes do checkbox.
    * Primeiro ele filtra na lista de checkbox pra ver se o checkbox existe na lista
    * Depois ele inclui ou altera o valor do checkbox.
    */
  updateMultipleComponent(
    option: number,
    valorOpcao: any,
    item: number,
    pergunta: number
  ) {
    // busco pra ver se a opcao jah existe no meu array
    let existe = this.multipleComponentChecked
      .filter(valor => valor.idOpcao == option && valor.idPergunta == pergunta);
    if (!existe || (existe && existe.length == 0)) {
      this.multipleComponentChecked.push({
        idOpcao: option,
        value: valorOpcao,
        idItem: item,
        idPergunta: pergunta
      });
    } else {
      // agora filtro o meu resultado novamente e faco o map mudado o valor pro valor atual
      this.multipleComponentChecked
        .filter(valor => valor.idOpcao == option && valor.idPergunta == pergunta)
        .map(valor => {
          valor.value = valorOpcao;
          if (item && item != 0) {
            valor.idItem = item;
          }

          // se o valor mudou pra falso, tenho que apagar os valores das respostas vinculadas a ela
          if (valor.value == false) {
            this.apagaFilhosMultiple(option);
          }
        });
    }
  }
  /*
  * Metodo usado para apagar os filhos de uma pergunta vinculada.
  * Exemplo: Tenho uma pergunta B vinculada a opção 1 da pergunta A. Porem, eu alterei a opcao 1 para 2. Então a pergunta B deve ser null.
  */
  apagaFilhos(question: any) {
    let valorOpcao: number = this.form.controls[question.key].value;
    if (question.options) {
      for (let op in question.options) {
        let opcao: OpcaoGenerica = question.options[op];
        if (opcao.id != valorOpcao) {
          //agora pego a perguntaVinculada da questao e
          let pergunta: any = this.form.controls[question.key];
          // agora percorro por minhas perguntas respondidas, procurando por alguma pergunta que seja vinculada a opcao corrente
          for (let id in this.form.controls) {
            // esse filter chega com um array preenchio
            let perguntaPraApagar: Question = this.questionModel.questions.find(
              (x: Question) => x.key == parseInt(id)
            );
            if (perguntaPraApagar.perguntaVinculada) {
              if (perguntaPraApagar.perguntaVinculada.idOpcao == opcao.id) {

                //aqui tenho que ver seh eh checkbox 
                if (perguntaPraApagar.controlType == 'select-multiple') {
                  for (let idArrayOption in perguntaPraApagar.options) {
                    let opcaoAtual: OpcaoGenerica = perguntaPraApagar.options[idArrayOption];
                    this.updateMultipleComponent(
                      opcaoAtual.id,
                      false,
                      0,
                      perguntaPraApagar.key
                    );
                  }

                } else {
                  // aki apago todas as perguntas que forem vinculadas a opcao dakela pergunta
                  this.form.controls[perguntaPraApagar.key].patchValue("");
                  // agora chamo o metodo, recursivamente, pra apagar a opcao da pergunta que vai ser apagada
                  this.apagaFilhos(perguntaPraApagar);
                }
              }
            }
          }
        }
      }
    }
  }

  /*
  * Metodo usado para apagar os filhos de uma pergunta vinculada quando o multiple eh marcado pra false.
  */
  apagaFilhosMultiple(option: number) {
    // esse filter chega com as perguntas pra apagar
    let listaPerguntaPraApagar: Question[] = this.questionModel.questions
      .filter((x: Question) => x.perguntaVinculada != null)
      .filter((x: Question) => x.perguntaVinculada.idOpcao == option);

    for (let id in listaPerguntaPraApagar) {
      let perguntaPraApagar: Question = listaPerguntaPraApagar[id];
      if (perguntaPraApagar) {
        this.form.controls[perguntaPraApagar.key].patchValue("");
        if (perguntaPraApagar.controlType == "arquivo") {
          //this.removeArquivoDaListaArquivo(perguntaPraApagar.key + "");
        }
        //else if(perguntaPraApagar.controlType == "select-multiple"){ achei melhor nao apagar as do selectMultiple, pq senao ia dar muito problema pra apagar os filhos dela
      }
    }
  }

  public carregarCategoria(categoria: CategoriaPergunta) {
    this.categoriaSelecionada = categoria;
  }

  public save(formulario: any) {
    //this.validaForm(isValid);

    this.resposta = this.preencheResposta(); // o metodo de preencheResposta contrala a vlidade de cada uma
    if (this.respostaValida) {
      if (this.parametroMetodoValidador) { // adiciono o parametro do método validador se existir
        this.resposta.parametroMetodoValidador = this.parametroMetodoValidador;
      }

      this.salvando = true;
      // desabiloto o botão duas vezes pra evitar que o usuario clique novamente durante a requisição
      this.botaoSalvar = false;
      this.questionarioDinamicoService.updateResposta(this.resposta).subscribe(
        (retorno: Resposta) => {
          this.resposta = retorno;
          this.resposta.listaRespostaItemArquivo =
            retorno.listaRespostaItemArquivo;
          // tenho que fazer o update aki dos id(principalmente por conta dos checkboxs)
          this.recuperaResposta(retorno, 0);
          // this.mensagem = ["Registro salvo com sucesso!", "alert-info"];
          this.respostaEmitida.emit(this.resposta.id);
          this.respostaCompletaEmitida.emit(this.resposta);
          this.situacaoEmitida.emit(this.resposta.situacao);
          if (this.mostrarMensagemSalvar) {
            this.mensagemSnack.open("Registro salvo com sucesso!", "X", {
              duration: 5000
            });
          }
          // aki tenho que resetar o mostrarMensagemSalvar, pq quem manda nele eh o Continuar
          this.mostrarMensagemSalvar = true;

          if (this.mensagemErros) {
            this.mensagemErros.length = 0;
          }
          this.botaoSalvar = true;
          this.salvando = false;
        },
        error => {
          this.erro(error);
          this.botaoSalvar = true;
          this.salvando = false;
        }
      );
      window.scrollTo(0, 0);
      this.situacaoResposta = 0;
    }
  }

  public selecionarPergunta(idPergunta: number) {
    this.perguntaEmitida.emit(idPergunta);
  }

  public validaResposta(retorno: Resposta) { }

  public saveConcluir(formulario: any) {
    this.situacaoResposta = SituacaoEnum.Concluido;
    this.save(formulario);
  }

  public continuar(formulario: any) {
    this.mostrarMensagemSalvar = false;
    this.tabAtual += 1;
    this.save(formulario);
  }

  public preencheResposta() {
    let resposta: Resposta = new Resposta();

    resposta.listaRespostaItem = new Array();
    // caso seja alteracao recupero o idResposta
    if (this.resposta && this.resposta.id) {
      resposta.id = this.resposta.id;
    }

    // verifico se a situacao foi preenchida, se nao foi, entao eh pq eh Concluido
    if (
      this.situacaoResposta ||
      (this.situacaoResposta != null && this.situacaoResposta != 0)
    ) {
      resposta.situacao = this.situacaoResposta;
    }
    this.respostaValida = true;
    this.questionario.categorias.forEach(cat => {
      cat.perguntas.forEach(per => {
        let itemResposta: RespostaItem = new RespostaItem();
        // se for uma alteracao, tenho que preencher o id do itemResposta
        if (this.resposta && this.resposta.id) {
          itemResposta.id = this.preencheIdItem(per.id);
        }
        resposta.questionario = this.questionario.id;
        itemResposta.pergunta = per.id;
        // 0 escolha uma, 1 multipla escolha, 4 combo
        if (
          per.tipoResposta == TipoRespostaEnum.EscolhaUma ||
          per.tipoResposta == TipoRespostaEnum.Combo
        ) {
          if (this.form.controls[per.id].value != "") {
            // tenho que recuperar a opcao com base na pergunta preenchida
            let itemRespostaOpcaoPreenchida = this.questionarioDinamicoService.preencherOpcao(
              per,
              this.form.controls[per.id].value
            );
            itemResposta.opcao = itemRespostaOpcaoPreenchida.opcao;
            itemResposta.opcaoValor = itemRespostaOpcaoPreenchida.opcaoValor;
            resposta.listaRespostaItem.push(itemResposta);
          }
        } else if (
          per.tipoResposta == TipoRespostaEnum.TextoSimples ||
          per.tipoResposta == TipoRespostaEnum.TextoGrande ||
          per.tipoResposta == TipoRespostaEnum.Divisor
        ) {
          if (this.form.controls[per.id].value != "") {
            itemResposta.descricao = this.form.controls[per.id].value;
            resposta.listaRespostaItem.push(itemResposta);
          }
        } else if (per.tipoResposta == TipoRespostaEnum.Inteiro) {
          if (this.form.controls[per.id].value != "") {
            if (this.validaInteiro(this.form.controls[per.id].value)) {
              itemResposta.numero = this.form.controls[per.id].value;
              resposta.listaRespostaItem.push(itemResposta);
            }
          }
        } else if (per.tipoResposta == TipoRespostaEnum.Decimal) {
          if (this.form.controls[per.id].value != "") {
            if (this.validaDecimal(this.form.controls[per.id].value)) {
              itemResposta.numero = this.form.controls[per.id].value;
              resposta.listaRespostaItem.push(itemResposta);
            }
          }
        } else if (per.tipoResposta == TipoRespostaEnum.Data) {
          if (this.form.controls[per.id].value != "") {
            if (this.validaData(this.form.controls[per.id].value)) {
              itemResposta.data = this.form.controls[per.id].value;
              resposta.listaRespostaItem.push(itemResposta);
            }
          }
        } else if (per.tipoResposta == TipoRespostaEnum.Arquivo) {
          if (this.listaArquivos) {
            let listaArquivosPorPergunta = this.listaArquivos.filter(
              x => x.idPergunta == per.id
            );
            listaArquivosPorPergunta.forEach((arquivo: FileUpload) => {
              if (!arquivo.idRespostaItem) {
                // eu soh quero adicionar arquivos novos, ou seja, sem o idRespostaItem
                let item: RespostaItem = new RespostaItem();
                item.pergunta = arquivo.idPergunta;
                item.itemRespostaArquivo = arquivo.id;
                resposta.listaRespostaItem.push(item);
              }
            });
          }
        } else if (per.tipoResposta == TipoRespostaEnum.MultiplaEscolha) {
          this.multipleComponentChecked.forEach(x => {
            // tenho que verificar se a pergunta q estou inserindo tem o mesmo id da pergunta no multipleComponentChecked
            // se nao tiver isso ele inclui mais de uma vez se tiver dois componentes de checkbox
            if (per.id == x.idPergunta) {
              let item: RespostaItem = new RespostaItem();
              if (x.idItem && x.idItem != 0) {
                item.id = x.idItem;
              }
              item.pergunta = x.idPergunta;
              item.opcao = x.idOpcao;
              if (x.value == true) {
                item.opcaoValor = x.idOpcao;
              } else {
                // essa eh uma forma de falar que o item foi excluido
                item.opcaoValor = 0;
              }
              resposta.listaRespostaItem.push(item);
            }
          });
        }
      });
    });
    return resposta;
  }

  public validaForm(isValid: boolean) {
    this.mensagemErros = new Array();
    //this.resposta = null;
    for (let id in this.form.controls) {
      if (!this.form.controls[id].valid) {
        this.mensagem = ["", ""];
        for (let questao in this.questionModel.questions) {
          // acho q questao
          if (this.questionModel.questions[questao].key == id) {
            // agora procuro pela categoria da questao
            for (let cat in this.categorias) {
              // question.perguntaVinculada == null || (question.perguntaVinculada !=null && form.controls[question.perguntaVinculada.opcao.pergunta].value == question.perguntaVinculada.idOpcao)

              if (
                this.questionModel.questions[questao].perguntaVinculada ==
                null ||
                (this.questionModel.questions[questao].perguntaVinculada !=
                  null &&
                  this.form.controls[
                    this.questionModel.questions[questao].perguntaVinculada
                      .opcao.pergunta
                  ].value ==
                  this.questionModel.questions[questao].perguntaVinculada
                    .idOpcao)
              ) {
                if (
                  this.categorias[cat].id ==
                  this.questionModel.questions[questao].idCategoria
                ) {
                  // aqui tem que fazer um tratamento especial para checkbox por conta de um erro no HTML fix
                  // por isso, se for checkbox, eu deixo o backend validar
                  if (
                    this.validaCheckBox(this.questionModel.questions[questao])
                  ) {
                    if (this.questionario.mostrarCategoria) {
                      this.mensagemErros.push(
                        this.categorias[cat].denominacao +
                        ": " +
                        this.questionModel.questions[questao].text +
                        " campo obrigatório."
                      );
                    } else {
                      this.mensagemErros.push(
                        this.questionModel.questions[questao].text +
                        " campo obrigatório."
                      );
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  public validaCheckBox(question: Question) {
    if (question.controlType == "select-multiple") {
      return false;
    } else {
      return true;
    }
  }

  public tabChanged(event: any) {
    this.tabAtual = event.index;
  }

  public resetar() {
    // TODO: Implementar resetando campo por campo (nao montando novamente o formulario)
    this.resposta = new Resposta();
    if (this.mensagem) {
      // TODO: verificar porque não funciona com 0 e nçao funciona com 2
      this.mensagem.length = 2;
    }
    if (this.mensagemErros) {
      this.mensagemErros.length = 0;
    }
    this.listaArquivos = new Array();

    this.multipleComponentChecked = new Array<{
      idOpcao: number;
      value: boolean;
      idItem: number;
      idPergunta: number;
    }>();
    this.carregaQuestionario(this.idQuestionario, this.nomeQuestionario, this.questionarioPreCarregado);
  }

  public preencheIdItem(idPergunta: number) {
    let itemCodigo: number = 0;
    for (let item of this.resposta.listaRespostaItem) {
      if (item.pergunta == idPergunta) {
        itemCodigo = item.id;
        break;
      }
    }
    return itemCodigo;
  }

  public arquivoIncluidoEmitido(arquivo: FileUpload) {
    if (!this.listaArquivos) {
      this.listaArquivos = new Array();
    }
    this.listaArquivos.push(arquivo);
  }

  public arquivoExcluidoEmitido(arquivo: FileUpload) {
    var index = this.listaArquivos.indexOf(arquivo, 0);
    if (index > -1) {
      this.listaArquivos.splice(index, 1);
    }
  }

  // mostra erros na tela
  public erro(erro: Array<string>) {
    this.mensagemErros = new Array();
    if (erro instanceof Array) {
      for (let entry of erro) {
        this.mensagemErros.push(entry);
      }
    } else {
      this.mensagemErros.push(erro);
    }
    this.mensagemSnack.open(
      "Existem erros no formulário, por favor, verifique.",
      "X",
      { duration: 5000 }
    );
    this.isLoading = false;
  }

  // finaliza o subscribe
  public finaliza() {
    this.isLoading = false;
  }

  public converteDecimal(key: any) {
    let valor: any = this.form.controls[key].value;
    if (valor) {
      valor = valor.replace(/,/g, ".");
      let listaValor: string[] = valor.split(".");
      let decimal: string = "";
      let inteiro: string = "";
      if (listaValor.length > 1) {
        // pego o ultimo que eh o decimal
        decimal = listaValor[listaValor.length - 1];
        // pro resto, somo no inteiro sem pegar o ultimo
        for (var i = 0; i < listaValor.length - 1; i++) {
          inteiro += listaValor[i];
        }
        //retiro os pontos do inteiro
        valor = inteiro + "." + decimal;
      }

      if (isNaN(valor)) {
        // se nao for numero
        this.form.controls[key].patchValue(""); // preencho vazio
      } else {
        this.form.controls[key].patchValue(parseFloat(valor).toFixed(2));
      }
    } else {
      this.form.controls[key].patchValue(""); // preencho vazio
    }
  }

  public validaData(data: any): boolean {
    // o componente jah tenta converter pra data. Se ele nao conseguir, ele retorna um null (por isso não precisamos fazer a conversao e testar)
    if (data == null) {
      this.respostaValida = false;
      this.mensagemSnack.open(
        "Data inválida. Utilize o formato: dd/mm/aaaa (dia/mês/ano)",
        "X",
        { duration: 5000 }
      );
      return false;
    } else {
      return true;
    }
  }

  public validaInteiro(value: any): boolean {
    if (isNaN(value)) {
      this.respostaValida = false;
      this.mensagemSnack.open(
        "Valor não é um número inteiro: '" +
        value +
        "'. Por favor, informe um número válido. ",
        "X",
        { duration: 5000 }
      );
      return false;
    } else {
      return true;
    }
  }

  public validaDecimal(value: any): boolean {
    if (isNaN(value)) {
      this.respostaValida = false;
      this.mensagemSnack.open(
        "A resposta: '" +
        value +
        "' não é um valor válido. Por favor, informe um número decimal. ",
        "X",
        { duration: 5000 }
      );
      return false;
    } else {
      return true;
    }
  }
}

